import { State, Action, StateContext } from '@ngxs/store';
import { ContractStateModel } from '../../models/contract.model';
import {
  DownloadContractAction,
  ContractResetAction,
  DownloadContractSuccessAction,
  DownloadContractFailedAction,
} from './contract.actions';
import { ContractService } from '../../services/contract.service';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { NotificationService } from '@core/services/notification.service';
import { Injectable, inject } from '@angular/core';
import { catchError, take, tap } from 'rxjs';

enum Messages {
  SMSContractSent = 'SMS kontrakt utsendt',
  SMSContractFailed = 'Feil ved utsendelse av SMS kontrakt',
  SignContractSuccess = 'Kontrakt sendt til kunde for signering.',
  SignContractFailed = 'Feil ved signering av kontrakt',
  NoContractFound = 'Fant ikke kontrakten.',
  DownloadContractFailed = 'Feil ved nedlasting av kontrakten',
}

const initialContractState: ContractStateModel = {
  isLoadingPaperContract: false,
  isLoadingEmailSent: false,
  isLoadingSmsSent: false,
  smsContractLines: [],
  smsExchange: [],
};

@State<ContractStateModel>({
  name: 'contract',
  defaults: initialContractState,
})
@Injectable()
export class ContractState {
  private contractService = inject(ContractService);
  private notificationService = inject(NotificationService);

  @Action(DownloadContractAction)
  public downloadContractAction({ dispatch }: StateContext<ContractStateModel>, { contractId }: DownloadContractAction) {
    if (!contractId) {
      this.notificationService.error(Messages.NoContractFound);
      return;
    }

    return this.contractService.getPdfContract(contractId).pipe(
      take(1),
      tap((response: Blob) => {
        const dataType = response?.type;
        const binaryData = [response];
        const contractUrl = URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        dispatch(new DownloadContractSuccessAction(contractUrl));
      }),
      catchError((error: HttpErrorResponse) => dispatch(new DownloadContractFailedAction(error, contractId)))
    );
  }

  @Action(DownloadContractSuccessAction)
  downloadContractSuccessAction(_: StateContext<ContractStateModel>, { fileDownloadLink }: DownloadContractSuccessAction) {
    window.open(fileDownloadLink, 'Download');
  }

  @Action(DownloadContractFailedAction)
  downloadContractFailedAction(_: StateContext<ContractStateModel>, { error, contractId }: DownloadContractFailedAction) {
    this.notificationService.error(
      error.status === HttpStatusCode.NotFound
        ? `Pdf kontrakten "${contractId}" finnes ikke.`
        : Messages.DownloadContractFailed
    );
  }

  @Action(ContractResetAction)
  public contractReset({ setState }: StateContext<ContractStateModel>) {
    setState(initialContractState);
  }
}
